import { MenuItem } from '../models/menu/menu.model';
import { ROUTE_IDENTIFIER_NAMES } from '../models/route-identifiers/route-identifiers.model';
import { SECURITY_ROLE_KEY } from '../models/security/security-role-keys';

export const pepperMenu: MenuItem[] = [
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.COMPETENCY_CLAIMS,
    hideItem: true,
    securityRoles: [],
  },
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.COMPETENCY_ASSESSMENTS,
    hideItem: true,
    securityRoles: [],
  },
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.EVENTS_CALENDAR,
    hideItem: true,
    securityRoles: [],
  },
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.MATRICES,
    hideItem: true,
    securityRoles: [],
  },
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.ANALYSIS,
    securityRoles: SECURITY_ROLE_KEY.User,
    subMenu: [
      {
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ANALYSIS_JOB_ROLES,
        hideItem: true,
        securityRoles: [],
      },
      {
        routeIdentifier:
          ROUTE_IDENTIFIER_NAMES.ANALYSIS_COMPETENCY_TRAINING_ANALYTICS,
        hideItem: true,
        securityRoles: [],
      },
      {
        routeIdentifier:
          ROUTE_IDENTIFIER_NAMES.ANALYSIS_TRAINING_MATRIX_SUMMARY,
        hideItem: true,
        securityRoles: [],
      },
    ],
  },
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN,
    securityRoles: SECURITY_ROLE_KEY.JobRolePeople,
    subMenu: [
      {
        hideItem: true,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_CAPABILITY_FRAMEWORK,
        securityRoles: [],
      },
      {
        hideItem: true,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_MATRIX_SETTINGS,
        securityRoles: [],
      },
      {
        hideItem: true,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_CAPABILITY_PASSPORT,
        securityRoles: [],
      },
      {
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_OBSERVATION_CHECKLISTS,
        hideItem: true,
      },
      {
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_QUESTION_LISTVIEW,
        hideItem: true,
      },
      {
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_OBSERVATION_CHECKLISTS,
        hideItem: true,
      },
      {
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_QUESTION_LISTVIEW,
        hideItem: true,
      },
      {
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_COMPETENCY_LIBRARY,
        hideItem: true,
      },
      {
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_LEVEL_GROUP_LIBRARY,
        hideItem: true,
      },
    ],
  },
];
